import { isNative } from '../utils/platformUtils';

// Meme raison que openPrivacyPolicy : sur natif, une ancre externe reste dans
// la WebView, page hors de l'app et sans retour.
export async function openExternal(url) {
  if (!url) return;
  if (isNative()) {
    const { Browser } = await import('@capacitor/browser');
    await Browser.open({ url });
  } else {
    window.open(url, '_blank', 'noopener');
  }
}

export default openExternal;
